import React from "react";

const SitewideDataContext = React.createContext({});

export default SitewideDataContext;